
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("lMsFR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $8f167b402b2dee87$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //French (France)
var $8f167b402b2dee87$export$2e2bcd8739ae039 = {
    'fabric.reactions.add': "Ajouter une r\xe9action",
    'fabric.reactions.error.unexpected': "Les r\xe9actions sont temporairement indisponibles",
    'fabric.reactions.loading': "Chargement\u2026",
    'fabric.reactions.more.emojis': "Plus d'\xe9motic\xf4nes",
    'fabric.reactions.other.reacted.users': "{count, plural, one {et 1\xa0autre} other {et {count}\xa0autres}}",
    'fabric.reactions.reactwithemoji': "R\xe9agir avec l'\xe9motic\xf4ne\xa0{emoji}",
    'fabric.reactions.summary': "Afficher toutes les r\xe9actions des utilisateurs",
    'reaction-picker-trigger.add.reaction.message': "Ajoutez une r\xe9action",
    'reactions.dialog.close': 'Fermer',
    'reactions.dialog.emoji.name': '{emojiName}',
    'reactions.dialog.left.navigate': 'Naviguer vers la gauche',
    'reactions.dialog.reactions.count': "{count, plural, one {{count,number}\xa0r\xe9action au total} other {{count,number}\xa0r\xe9actions au total}}",
    'reactions.dialog.right.navigate': 'Naviguer vers la droite',
    'reactions.dialog.viewall': 'Afficher tout',
    'reactions.dialog.viewall.tooltip': "Afficher toutes les r\xe9actions des utilisateurs"
};

});


//# sourceMappingURL=fr.51cb3940.js.map
